export class GraphData {
    constructor(
        public systemId : string,
        public subSystemId: string,
        public dateTime : Date,
        public value: number
    ){}
}



// WEBPACK FOOTER //
// ./src/app/models/graph-data.ts